<template>
	<div class="main__content">
		<aside ref="aside" :class="{'toggled': navToggled}">
			<div class="pb-5 aside__container" ref="logo">
				<router-link to="/"><img src="@/assets/bkk-fogas-logo.svg" aria-label="BKK telebusz" class="w-100" alt="BKK telebusz" /></router-link>
			</div>

			<nav>
				<ul class="navigation" ref="navigation">
					<li class="navigation__item">
						<router-link @click.native="navToggled = false;" :to="{name: 'demand-request'}" class="navigation__link">
							<span class="navigation__icon">
								<inline-svg :src="require('@/assets/icons/bus.svg')"></inline-svg>
							</span>
							<span>{{$t('Járat igénylés')}}</span>
						</router-link>
					</li>
					<li class="navigation__item">
						<router-link @click.native="navToggled = false;" :to="{name: 'requests'}" class="navigation__link">
							<span class="navigation__icon">
								<inline-svg :src="require('@/assets/icons/previous.svg')"></inline-svg>
							</span>
							<span>{{$t('Igényléseim')}}</span>
						</router-link>
					</li>
					<li class="navigation__item">
						<router-link @click.native="navToggled = false;" :to="{name: 'favourites'}" class="navigation__link">
							<span class="navigation__icon">
								<inline-svg :src="require('@/assets/icons/favourite.svg')"></inline-svg>
							</span>
							<span>{{$t('Kedvencek')}}</span>
						</router-link>
					</li>
					<li class="navigation__item">
						<router-link @click.native="navToggled = false;" :to="{name: 'settings'}" class="navigation__link">
							<span class="navigation__icon">
								<inline-svg :src="require('@/assets/icons/settings.svg')"></inline-svg>
							</span>
							<span>{{$t('Beállítások')}}</span>
						</router-link>
					</li>
					<li class="navigation__item">
						<a href="/docs/terms_of_service.pdf" class="navigation__link">
							<span class="navigation__icon">
								<inline-svg :src="require('@/assets/icons/doc.svg')"></inline-svg>
							</span>
							<span>{{$t('ÁSZF')}}</span>
						</a>
					</li>
					<li class="navigation__item">
						<a href="/docs/privacy_policy.pdf" class="navigation__link">
							<span class="navigation__icon">
								<inline-svg :src="require('@/assets/icons/doc.svg')"></inline-svg>
							</span>
							<span>{{$t('Adatkezelési nyilatkozat')}}</span>
						</a>
					</li>
					<li class="navigation__item">
						<a href="javascript:void(0);" @click.prevent.stop="logout()" class="navigation__link">
							<span class="navigation__icon">
								<inline-svg :src="require('@/assets/icons/logout.svg')"></inline-svg>
							</span>
							<span>{{$t('Kijelentkezés')}}</span>
						</a>
					</li>
				</ul>
			</nav>
			<ul class="aside__logos aside__logos--fixed" ref="aside-logos">
				<li class="aside__logo">
					<a href="https://www.interreg-central.eu/smacker" target="_blank" class="d-block">
						<img style="width:110px" src="@/assets/interreg-logo.png" alt="Interreg Central Europe" />
					</a>
				</li>
				<li class="aside__logo">
					<a href="https://bkk.hu" target="_blank" class="d-block">
						<img src="@/assets/bkk-logo.svg" alt="BKK" />
					</a>
				</li>
			</ul>
		</aside>

		<main>
			<div class="main__inner">
				<router-view />
			</div>
		</main>

        <header class="d-block d-lg-none px-2">
            <div class="form-row align-items-center">
                <div class="col-auto">
                    <button class="header__button" @click="navToggled = true;"><img src="@/assets/icons/hamburger.svg" :alt="$t('Navigáció')"></button>
                </div>
                <div class="col font-weight-bold text-biggest">
                    {{$t('BKK telebusz')}}
                </div>
                <div class="col-auto">
                    <router-link :to="{name: 'favourites'}" tag="button" class="header__button"><inline-svg :src="require('@/assets/icons/favourite.svg')"></inline-svg></router-link>
                </div>
            </div>
        </header>
        <div class="mobile-nav-close" :class="{'toggled': navToggled}" @click="navToggled = false;"></div>
	</div>
</template>

<script>
export default {
	name: "Main",
	data: () => {
		return {
            navToggled: false
        };
	},
	computed: {},
	watch: {},
	methods: {
		setAsideLogosClass: function () {

            if(typeof this.$refs["aside-logos"] === "undefined" || typeof this.$refs["aside"] === "undefined" || typeof this.$refs["logo"] === "undefined" || typeof this.$refs["navigation"] === "undefined") {
                return false;
            }

			let asideLogos = this.$refs["aside-logos"],
				asideHeight = this.$refs["aside"].offsetHeight - 50,
				logoHeight = this.$refs["logo"].offsetHeight,
				navHeight = this.$refs["navigation"].offsetHeight,
                logosHeight = asideLogos.offsetHeight;

			if (asideHeight > logoHeight + navHeight + logosHeight) {
				asideLogos.classList.add("aside__logos--fixed");
			} else {
				asideLogos.classList.remove("aside__logos--fixed");
			}
        },
        logout() {
            this.$store.commit('logout');
            this.$router.push({name: 'login'});
        }
	},
	created() {},
	mounted() {
        setTimeout(()=>{
            this.setAsideLogosClass();
        },300);
        window.addEventListener('resize', () => {
            this.setAsideLogosClass();
        });
	},
};
</script>
<style lang="scss" src="@/assets/scss/common.scss"></style>
<style lang="scss" src="@/assets/scss/swal-custom.scss"></style>
<style lang="scss" src="@/assets/scss/main.scss" scoped></style>
